export const ORGANIZATION = 'organization';
export const GROUPS = 'groups';
export const HEATMAP = 'heatmap';
export const OBSERVED = 'observed';
export const SUGGESTED = 'suggested';
